import { render } from "./PageSectionHeading.vue?vue&type=template&id=523eea58"
import script from "./PageSectionHeading.vue?vue&type=script&lang=js"
export * from "./PageSectionHeading.vue?vue&type=script&lang=js"

import exportComponent from "/var/app/current/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__